import { useState } from "react";

const ImageComponent = ({ className, src, onClick }) => {
  const [error, setError] = useState(false);

  return (
    !error && (
      <img
        alt=""
        className={className}
        src={src}
        style={{ height: "90vh" }}
        onClick={onClick}
        onError={() => setError(true)}
      />
    )
  );
};

export default ImageComponent;
